import { ResultOf } from "gql.tada";
import { GetFaqPageById } from "@queries/archetypes/GetFaqPageById";
import { FAQSection } from "@components/entries/FaqSection";

type FaqPageData = NonNullable<
  ResultOf<typeof GetFaqPageById>["faqPage"]
>;

export const FaqPageRenderer = ({ data }: { data: FaqPageData }) => {
  return (
    <>
      {data.faq && (
        <FAQSection entry={{ faqSection: data.faq } as any} />
      )}
    </>
  );
};
